<a
  class="items-list-item dashboard-item-pos"
  [attr.aria-label]="'Consulter votre facture ' + offer.name"
  [attr.data-e2e]="'e2e-dashboard-bill'"
  (click)="openLink(bill.link, bill.trackingData); (false)"
  [routerLink]="bill.link | link | async"
>
  <div class="item-container dashboard-anchor">
    <div class="item-text">
      <span class="lead pt-0"
        ><strong>{{ 'dashboard.bill' | translate }}</strong></span
      >
      @if (bill.amount && bill.date) {
        <small class="item-desc item-desc-price">{{ bill.date | date: 'longDate' }} : {{ bill.amount }} €</small>
      }
      <small class="item-desc">{{ 'dashboard.billLabel' | translate }}</small>
    </div>
  </div>
</a>
